<template>
    <div v-if="items.length > 0" id="related-products" class="my-10 space-y-6">
        <ProductPageSlider :items="items" :arrow-step="2" track-class="-mx-2 -mb-8 scroll-px-2 gap-3 px-2 pt-1 pb-8">
            <template #header>
                <h2 class="text-left text-xl font-black md:text-2xl onlywow:md:text-4xl" v-text="$t('components.related_products.section_title')" />
            </template>

            <template #default="{ item }">
                <CollectionSliderCard
                    :item="item"
                    class="w-[calc((100%-0.75rem)/1.5)] shrink-0 sm:w-[calc((100%-3*0.75rem)/3)] lg:w-[calc((100%-3*0.75rem)/4)]"
                />
            </template>
        </ProductPageSlider>
    </div>
</template>

<script setup lang="ts">
import ProductPageSlider from '@/components/sliders/ProductPageSlider.vue';
import type { AppPageProps } from '@/types';
import type { CollectionSliderItemObject } from '@/types/generated';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import CollectionSliderCard from '@/components/product/CollectionSliderCard.vue';

const page = usePage<AppPageProps & { related_products?: CollectionSliderItemObject[] }>();

const items = computed((): CollectionSliderItemObject[] => page.props.related_products ?? []);
</script>
